import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loading: -1,
    myClinics: -1,
    clinicsTo: -1,
    clinicDetail: -1,
  },
  list: [],
  myClinics: [],
  clinicsTo: [],
  error: null,
  currentClinicId: null,
  clinicDetail: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error, clinicId } = action;

  switch (type) {
    case ACTION_TYPES.CLINIC_GET_REQUESTED:
      return {
        ...state,
        status: {
          loading: 0,
        },
      };
    case ACTION_TYPES.CLINIC_GET_SUCCEED:
      return {
        ...state,
        status: {
          loading: 1,
        },
        list: payload.data,
      };
    case ACTION_TYPES.CLINIC_GET_FAILED:
      return {
        ...state,
        status: {
          loading: 2,
        },
        error,
      };
    case ACTION_TYPES.MY_CLINIC_GET_REQUESTED:
      return {
        ...state,
        status: {
          myClinics: 0,
        },
      };
    case ACTION_TYPES.MY_CLINIC_GET_SUCCEED:
      return {
        ...state,
        status: {
          myClinics: 1,
        },
        myClinics: payload.data,
      };
    case ACTION_TYPES.MY_CLINIC_GET_FAILED:
      return {
        ...state,
        status: {
          myClinics: 2,
        },
        error,
      };

    case ACTION_TYPES.TO_CLINICS_GET_BY_DOCTOR_REQUESTED:
      return {
        ...state,
        clinicsTo: [],
        status: {
          ...state.status,
          clinicsTo: 0,
        },
      };
    case ACTION_TYPES.TO_CLINICS_GET_BY_DOCTOR_SUCCEED:
      return {
        ...state,
        clinicsTo: payload.data,
        status: {
          ...state.status,
          clinicsTo: 1,
        },
      };
    case ACTION_TYPES.TO_CLINICS_GET_BY_DOCTOR_FAILED:
      return {
        ...state,
        clinicsTo: [],
        status: {
          ...state.status,
          clinicsTo: 2,
        },
        error: {
          ...state.error,
          clinicsTo: error,
        },
      };

    // getClinicDetail
    case ACTION_TYPES.CLINIC_DETAIL_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          clinicDetail: 0,
        },
      };

    case ACTION_TYPES.CLINIC_DETAIL_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          clinicDetail: 1,
        },
        clinicDetail: payload.data,
      };

    case ACTION_TYPES.CLINIC_DETAIL_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          clinicDetail: 2,
        },
        error: {
          ...state.error,
          clinicDetail: error,
        },
      };

    case ACTION_TYPES.SET_CURRENT_CLINIC_SELECTION:
      return {
        ...state,
        currentClinicId: clinicId,
      };

    default:
      return state;
  }
}
